export default class EditorEventHandler {
    constructor($filter, $timeout, $rootScope, Rest, $q, SweetAlert, Events, ImageBank) {
        this._timeout = $timeout;
        this._translator = $filter('translate');
        this._q = $q;
        this._rootScope = $rootScope;

        this.alerter = SweetAlert;
        this.rest = Rest.rest;
        this.imageBankRepo = ImageBank;
        this.eventHandler = Events;

        this.MAX_IMAGE_SIZE = 2000; //KB
        this.VALID_FORMATS = [ 'image/png', 'image/jpeg', 'image/jpg', 'image/gif' ];
    }

    static setImgWidthAndHeight(target, img) {
        let targetWidth = parseInt($(target).width());
        let ratio = targetWidth / $(img).width();
        let imgHeight = parseInt($(img).height() * ratio);

        $(img).attr('width', targetWidth);
        $(img).attr('height', imgHeight);
        $(img).css('height', '');
        $(img).css('width', '');
    };

    static isContentDrop(img, target, originUrl) {
        return (img.length == 0) && ($(target).closest('.content-drop-entry').length > 0) && (originUrl.length > 0);
    };

    static handleOgImage(imageSrc, element) {
        $(element).attr('height', null);
        $(element).css('height', '');
        $(element).attr('src', imageSrc);
        $(element).attr('data-cke-saved-src', imageSrc);
    };

    cleanUp(url, target) {
        this._timeout(() => { // Cleanup.
            target.parent().html(target.parent().html().replace(url, ''));
            $('.content-drop-overlay').remove();
        }, 100);
    };

    parseOpenGraphContent(openGraphContent, entryPoint) {
        // if find switch - apply openGraphContent only for active switch case;
        if ($(entryPoint).find('rm-block-switch').length) {
            let activeSwitchContent = $(entryPoint).find('rm-block-switch-case:visible')[0] || $(entryPoint).find('rm-block-switch-default');
            return this.parseOpenGraphContent(openGraphContent, activeSwitchContent);
        }

        Object.keys(openGraphContent).forEach((ogTagKey) => {
            let htmlComponent = $(entryPoint).find(`[data-og-property="${ ogTagKey }"]`);
            let ogTagValue = openGraphContent[ogTagKey];
            this.insertValueIntoComponent(htmlComponent, ogTagValue);
        });
    };

    parseSchemaContent(schemaContent, entryPoint) {
        angular.forEach($(entryPoint).find('[data-schema-property]'), (element) => {
            let attributeToFind = $(element).data('schema-property').split('.');
            let current = schemaContent[attributeToFind[0]] || "";

            if (attributeToFind.length > 1) {
                angular.forEach(attributeToFind, (part, index) => {
                    if (index > 0) {
                        current = current[part] || "";
                    }
                });
            }

            if ($(element).is('img')) {
                $(element).attr('src', current);
                $(element).attr('data-cke-saved-src', current);
            } else if ($(element).is('a')) {
                $(element).attr('href', current);
                $(element).attr('data-cke-saved-href', current);
            } else {
                $(element).html(current);
            }
        });
    };

    handleContentDrop(entryPoint, url, target) {
        let translation = this._translator('MAILEDITOR:FETCHING_OG');
        angular.element(entryPoint).append('<div class="content-drop-overlay">' + translation + '<br/>' + url + '</div>');

        if ($(entryPoint).find('.feed-duplicatable').length > 0) {
            this.dropFeed(entryPoint, url, target);
        } else {
            this.dropRemoteContent(entryPoint, url, target);
        }
    };

    dropRemoteContent(entryPoint, url, target) {
        this.rest.one('email').one('fetchRemoteContent').get({ url: url }).then((response) => {
            if (!response || response.length == 0) {
                this.eventHandler.flashEvent('error', this._translator('MAILEDITOR:CONTENT_DROP:EMPTY'));
                return this.cleanUp(url, target);
            }

            if (response.og) {
                this.parseOpenGraphContent(response.og, entryPoint);
            }

            if (response.schema) {
                this.parseSchemaContent(response.schema, entryPoint);
            }

            this.cleanUp(url, target);
        }, (error) => {
            if (error.status == 403) {
                this.eventHandler.flashEvent('error', this._translator('MAILEDITOR:CONTENT_DROP:NO_ACCESS'));
                return this.cleanUp(url, target);
            }
        });
    }

    dropFeed(entryPoint, url, target) {
        this.rest.one('email').one('fetchFeed').get({ url: url }).then((response) => {
            if (!response || response.length == 0) {
                this.eventHandler.flashEvent('error', this._translator('MAILEDITOR:CONTENT_DROP:EMPTY'));
                return this.cleanUp(url, target);
            }

            let length = $(entryPoint).find('.feed-duplicatable').first().attr('length');
            response = length ? response.slice(0, length) : response;

            let numberOfColumns = $(entryPoint).find('.feed-duplicatable').first().find('.feed-item').length;
            let numberOfArticles = response.length;
            let numberOfRows = Math.ceil(numberOfArticles / numberOfColumns);
            this.clearPreviouslyDuplicatedComponents(entryPoint);
            this.cloneFeedRows(entryPoint, numberOfRows);

            response.forEach((article, index) => {
                let feedBlock = $(entryPoint).find('.feed-duplicatable');
                let articleComponents = $(feedBlock).eq(Math.floor(index / numberOfColumns)).find('.feed-item');
                let currentArticle = $(articleComponents).eq(((index + 1) % numberOfColumns) - 1);

                Object.entries(article).forEach(([ key, value ]) => {
                    let htmlComponent = $(currentArticle).find(`[data-property="${ key }"]`);
                    this.insertValueIntoComponent(htmlComponent, value);
                })
            });

            this.cleanUp(url, target);
        }, (error) => {
            if (error.status == 403) {
                this.eventHandler.flashEvent('error', this._translator('MAILEDITOR:CONTENT_DROP:NO_ACCESS'));
            }
            return this.cleanUp(url, target);
        });
    }

    clearPreviouslyDuplicatedComponents(entryPoint) {
        let feedBlock = $(entryPoint).find('.feed-duplicatable');

        $(feedBlock).slice(1).remove();
    }

    cloneFeedRows(entryPoint, numberOfRows) {
        let feedBlock = $(entryPoint).find('.feed-duplicatable');

        for (let i = 0; i < numberOfRows - 1; i++) {
            $(feedBlock).first().clone().insertAfter($(feedBlock).first());
        }
    }

    insertValueIntoComponent(component, value) {
        switch (component.prop("tagName")) {
            case 'A':
                component
                    .attr('href', value)
                    .attr('data-cke-saved-href', value);
                break;
            case 'IMG':
                this.constructor.handleOgImage(value, component);
                break;
            default:
                this.insertTextContent(component, value);
        }
    }

    insertTextContent(component, value) {
        component.empty().append(this.decodeEntities(value));
    }

    attachErrorHandler(img, target) {
        let width = target.width();
        let height = target.height();

        $(img).error((error) => {
            this.eventHandler.flashEvent('error', this._translator('MAILEDITOR:FLASH:IMAGE_LINK_ERROR'));

            if (target.is('img')) {
                $(img).attr('src', target.attr('src'));
                img.attr('width', width);
                img.attr('height', height);
            }
        });
    };

    imageResizeMessage() {
        var deferred = this._q.defer();

        this.alerter.swal({
            title: this._translator('IMAGE_BANK:FLASH:FILE_SIZE_HEADER'),
            text: this._translator('IMAGE_BANK:FLASH:FILE_SIZE_BODY'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this._translator('GLOBAL:YES'),
            cancelButtonText: this._translator('GLOBAL:NO')
        }, (isConfirm) => {
            deferred.resolve([ isConfirm ]);
        });

        return deferred.promise;
    };

    imageStore(event, files) {
        const buildImageString = (image, altText = '') => {
            if (altText) {
                return `<img src="${ image.publicPath }" width="${ image.width }" height="${ image.height }" alt="${ altText }">`
            }

            return `<img src="${ image.publicPath }" width="${ image.width }" height="${ image.height }">`
        }

        const onImageStoreSuccess = (image, index, alt = '') => {
            const imageString = buildImageString(image, alt)

            if ($(event.target).is('img') && index === 0) {
                let target = $(event.target);
                let img = $(imageString);

                target.after(img);
                this.constructor.setImgWidthAndHeight(target, img);
                target.remove();
            } else {
                $(event.target).append(imageString);
            }
        }

        this.imageBankRepo.store(files).then((storeResponse) => {
            storeResponse.data.forEach((image, index) => {
                this.imageBankRepo.recognizeAltText(image.publicPath).then(({ alt }) => {
                    onImageStoreSuccess(image, index, alt);
                    this._rootScope.$emit('upload:images', storeResponse);
                }).catch(() => {
                    onImageStoreSuccess(image, index,);
                    this._rootScope.$emit('upload:images', storeResponse);
                })
            })
        });
    };

    handleDrop(event) {
        if (event.originalEvent.dataTransfer) {
            event.preventDefault();

            const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
            const types = event.originalEvent.dataTransfer.types;
            let isFileTransfer;

            if (isFirefox) {
                isFileTransfer = types.includes('Files');
            } else {
                isFileTransfer = types.length === 1 && types[0] === 'Files';
            }

            if (!isFileTransfer) {
                let target = $(event.target);
                let img = isFirefox
                    ? $(event.originalEvent.dataTransfer.getData('text/html')).find('img')[0]
                    : $(event.originalEvent.dataTransfer.getData('text/html')).filter('img');
                let originUrl = event.originalEvent.dataTransfer.getData("url");
                if (!originUrl) {
                    originUrl = event.originalEvent.dataTransfer.getData("text/x-moz-url").split('\n')[0];
                }
                if (img && img.length && this.isBase64Img(img)) {
                    this.eventHandler.flashEvent('error', this._translator('MAILEDITOR:FLASH:IMAGE_LINK_ERROR_BASE_64'));
                    return;
                }
                if (this.constructor.isContentDrop(img, target, originUrl)) { // Content element dropped.
                    let entryPoint = $(target).closest('.content-drop-entry');

                    if (event.originalEvent.dataTransfer.getData('text')) { // fix broken link drop in firefox
                        event.currentTarget.contentEditable = false;
                        this._timeout(() => {
                            event.currentTarget.contentEditable = true
                        });
                    }
                    this.handleContentDrop(entryPoint, originUrl, target);
                } else if (target.is('img')) { // Dropped Image on image-container.
                    this.attachErrorHandler(img, target);
                    target.after(img);
                    this.constructor.setImgWidthAndHeight(target, img);
                    target.remove();
                } else { // Image drop on non image container.
                    event.originalEvent.dataTransfer.effectAllowed === 'all' ? img.remove() : target.append(img);
                }
            }

            if (isFileTransfer && event.originalEvent.dataTransfer.files.length) {
                event.stopPropagation();
                let files = event.originalEvent.dataTransfer.files;
                let mimeType = event.originalEvent.dataTransfer.files[0].type;
                let fileSize = event.originalEvent.dataTransfer.files[0].size / 1024; //KB

                if (this.VALID_FORMATS.indexOf(mimeType) == -1) {
                    this.alerter.swal({
                        title: this._translator('IMAGE_BANK:UPLOAD_ERR'),
                        text: this._translator('IMAGE_BANK:FLASH:MIME_TYPE'),
                        type: "error"
                    });
                } else if (fileSize > this.MAX_IMAGE_SIZE) {
                    this.imageResizeMessage().then((isConfirm) => {
                        if (isConfirm[0]) {
                            this.imageStore(event, files);
                        }
                    });
                } else {
                    this.imageStore(event, files);
                }

                event.stopPropagation();
            }
        }
    };

    isBase64Img(img) {
        return $(img).attr('src').indexOf('data:image/jpeg;base64') !== -1 || $(img).attr('src').indexOf('data:image/png;base64') !== -1;
    }

    decodeEntities(encodedString) {
        const doc = new DOMParser().parseFromString(encodedString, "text/html");

        return doc.documentElement.textContent;
    }
};
